<script setup>
  import { computed, onMounted } from "vue"
  import GestorVentanas from "@/components/cotizador/GestorVentanas.vue"
  import CreateModal from "@/views/quote/CreateModal.vue"
  import { useAuth } from "@/composables/useAuth"

  const { user, loadUser } = useAuth()

  // Esta ruta no tiene meta.requiresAdmin, así que el guard global del
  // router nunca llama loadUser() acá -- sin esto, si es la primera
  // pantalla que carga tras el login, user.value llega null y el título
  // se queda en el fallback "Cotizador" sin el nombre de la empresa.
  // force=true: si la pestaña ya estaba abierta con un user.value cacheado
  // de antes de que /me devolviera companySlug, igual lo vuelve a pedir.
  onMounted(() => loadUser(true))

  // El slug puede llevar guiones como separador (ej. "Mena-Tour"); para
  // mostrarlo como título se reemplazan por espacios ("Mena Tour").
  const tituloCotizador = computed(() => {
    const slug = user.value?.companySlug
    return slug ? `Cotizador ${slug.replace(/-/g, " ")}` : "Cotizador"
  })
</script>

<template>

  <GestorVentanas storage-key="cotizador_ventanas_v1" :titulo="tituloCotizador" v-slot="{ ventana }">

    <CreateModal :activa="!ventana.minimizada" :sesion="ventana.sesionInicial"
      @update:estado="ventana.estado = $event" @update:resumen="ventana.resumen = $event"
      @update:job="ventana.job = $event" @update:datos="ventana.datos = $event" />

  </GestorVentanas>

</template>
